import React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import DispositivoForm from './DispositivoForm'
import { crudDispositivosApi } from '../../../actions/dispositivosApi.jsx';
import { useValue } from '../../../context/ContextProvider';
import { useDispositivosMutation } from '../../../hooks/mutations';
import { useAppStore } from '../../../store/appStore.tsx';


const AddDispositivo = () => {

    const queryClient = useQueryClient();
    //const { state: { currentUser } } = useValue();
    const currentUser = useAppStore(appStore => appStore.currentUser);

    //console.log (currentUser);

    /*
    const createDispositivoMutation = useMutation({
        //mutationFn: apiCreateDispositivo({token: currentUser.token, body=null})
        mutationFn: crudDispositivosApi,
        onSuccess: (mutationResponse) => {
            queryClient.invalidateQueries({ queryKey: ['dispositivos'] });
            //console.log(mutationResponse);
            //console.log('Dispositivo creado correctamente con id: ', mutationResponse.data.result.insertId);
        },
        onError: (error) => {
            //console.log('Error: Dispositivo no creado', error);
        }

    })
    */

    const dispositivosMutation = useDispositivosMutation();

    const handleAddDispositivo = (dispositivo) => {
        //console.log(dispositivo);
        //createDispositivoMutation.mutate({comando: "CMD_CREATE_DISPOSITIVO", token: currentUser.token, data: dispositivo});
        dispositivosMutation.mutate({comando: "CMD_CREATE_DISPOSITIVO", data: dispositivo, token: currentUser.token});
    }

    return (
        <div>
            <h3>Registrar nuevo dispositivo</h3>
            <DispositivoForm onSubmit={handleAddDispositivo} initialValue={{}} />
        </div>
    )
}

export default AddDispositivo